export default {
  title: "Statistiche dispositivi",
  description: "Analytics di prodotto del kiosk da PostHog (produzione).",
  iframeTitle: "Dashboard statistiche dispositivi PostHog",
  rangeLabel: "Periodo",
  ranges: {
    last7Days: "Ultimi 7 giorni",
    last30Days: "Ultimi 30 giorni",
    last90Days: "Ultimi 90 giorni",
    thisMonth: "Mese corrente",
    lastMonth: "Mese scorso",
  },
} as const;
